import 'angular:locale/data:fr';
import 'angular:locale/data:en';
import 'zone.js';
import 'temporal-polyfill/global';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
